/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 29/10/2021
 */

import {JournalEntryType} from "@shared/Journal/JournalEntryType";
import {JournalEntry} from "./journalEntry-imports";
import {PriorityEnum} from "@shared/enums/PriorityEnum";
import {daysDifferenceFormatted, timestampFormatted} from "@/utils/helpers";
import dayjs from 'dayjs'
// import ScheduledEvent from "@shared/scheduler/ScheduledEvent";

export default class TaskJournalEntry extends JournalEntry {

	priority: PriorityEnum = PriorityEnum.MEDIUM
	dueDateTs: number = 0
	isCompleted: boolean = false
	completionDateTs: number = 0


	lastResentTs: number = null
	resendAttempts: number = null
	nextReminderTs: number = null

	_isDueDateChanged: boolean = false
	_isCompletedChanged: boolean = false

	constructor() {
		super(JournalEntryType.TASK);
	}

	createQwoachEvent(coachId, teamMemberId){
		let qwoachEvent = {}//new ScheduledEvent()

		qwoachEvent.coachId = coachId || null
		qwoachEvent.clientId = this.clientId
		qwoachEvent.name = this.clientName + " - " + this.description
		qwoachEvent.startTime = this.dueDateTs
		qwoachEvent.duration = 60 * 60 * 1000
		if(teamMemberId){
			qwoachEvent.teamMemberId = teamMemberId
		}

		qwoachEvent.isBusy = false
		qwoachEvent.isAllDay = true

		return qwoachEvent
	}


	dueDateFormatted(){
		if(this.dueDateTs){
			return "Due on " + timestampFormatted(this.dueDateTs)
		}
		return ""//"No Due Date"
	}

	hasDueDate(){
		return !!this.dueDateTs
	}

	isDue(){
		return this.hasDueDate() && !this.isCompleted && this.dueDateTs < new Date().getTime()
	}

	completionsDateFormatted(){
		if(this.completionDateTs){
			return timestampFormatted(this.completionDateTs)
		}
		return ""//"No Due Date"
	}
	setCompleted(){
		this.isCompleted = true
		this.completionDateTs = new Date().getTime()
	}

	getSentDate(){
		return this.sentDateTs || this.createdAt
	}

	sentDateFormatted(){
		let sentDate = this.getSentDate()
		if(sentDate){
			return timestampFormatted(sentDate)
		}
		return ""//"No Due Date"
	}
	lastResentDateFormatted(){
		if(this.lastResentTs){
			return daysDifferenceFormatted(this.lastResentTs)
		}
		return ""//"No Due Date"
	}

	sentAgoFormatted(){
		let sentDate = this.getSentDate()
		if(sentDate){
			return daysDifferenceFormatted(sentDate)
		}
		return ""//"No Due Date"

	}



	toggleCompletion(){
		this.isCompleted = !this.isCompleted
		if(this.isCompleted){
			this.setCompleted()
		}
	}

	isDueToday(){
		return this.isUpcomingTask(0)
		//
		// let endOfDay = moment().endOf('day').valueOf()
		// return this.dueDateTs && this.dueDateTs <= endOfDay
	}
	isDueTomorrow(){
		return !this.isDueToday() && this.isUpcomingTask(1)
		// let tomorrow = moment().add(1, 'day')
		// let startOfDay = tomorrow.startOf('day').valueOf()
		// let endOfDay = tomorrow.endOf('day').valueOf()
		// return startOfDay <= this.dueDateTs && this.dueDateTs <= endOfDay
	}
	isDue7Days(){
		return this.isUpcomingTask(7)
		// let today = moment().valueOf()
		// let tomorrow = moment().add(7, 'day')
		// let endOfDay = tomorrow.endOf('day').valueOf()
		// return today <= this.dueDateTs && this.dueDateTs <= endOfDay
	}
	isDue30Days(){
		return this.isUpcomingTask(30)
		// let today = moment().valueOf()
		// let tomorrow = moment().add(30, 'day')
		// let endOfDay = tomorrow.endOf('day').valueOf()
		// return today <= this.dueDateTs && this.dueDateTs <= endOfDay
	}

	isUpcomingTask(thresholdDays){
		let now = dayjs().valueOf()
		let future = dayjs().add(thresholdDays, 'day').endOf('day').valueOf()
		return !this.isCompleted && now <= this.dueDateTs && this.dueDateTs <= future
	}

	isOverdue(){
		let now = dayjs().valueOf()
		return !this.isCompleted && 0 < this.dueDateTs  && this.dueDateTs < now
	}

	setPriorityHigh(){
		this.priority = PriorityEnum.HIGH
	}
	setPriorityUrgent(){
		this.priority = PriorityEnum.URGENT
	}


}
